// Frontend/src/data/sectors.js
export const sectors = [
  { key: "renovation", icon: "fa-hammer" },
  { key: "construction", icon: "fa-building" },
  { key: "domes", icon: "fa-church" },
  { key: "events", icon: "fa-calendar-check" },
  { key: "industrial", icon: "fa-industry" },
  { key: "oilGas", icon: "fa-fire" },
  { key: "marine", icon: "fa-ship" }
]
